interface SwitchProps {
    id: string;
    label: string;
    description?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
}

const Switch = ({ id, label, description, checked, onChange, disabled = false, className = '' }: SwitchProps) => (
    <div className={`d-flex align-items-center gap-16 ${className}`}>
        <div className="flex-1">
            <div id={`${id}-label`} className="font-weight-600">
                {label}
            </div>
            {description !== undefined && (
                <div id={`${id}-description`} className="help-block font-size-xs mt-4">
                    {description}
                </div>
            )}
        </div>
        <label className="switch switch-lg flex-shrink-0 mb-0" htmlFor={id}>
            <input
                id={id}
                type="checkbox"
                aria-labelledby={`${id}-label`}
                aria-describedby={description === undefined ? undefined : `${id}-description`}
                disabled={disabled}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span className="togglemark" />
        </label>
    </div>
);

export default Switch;
